import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getEndorsementsLayoutPageData } from './api/getEndorsementsLayoutPageData';
import type { EndorsementsLayoutPageDataErrorCode } from './types';

export const {
	Context: EndorsementsLayoutPageDataContext,
	Provider: EndorsementsLayoutPageDataContextProvider,
	useContext: useEndorsementsLayoutPageData,
	useAsyncData: useEndorsementsLayoutPageDataFromApi,
	prefetchAsyncData: prefetchEndorsementsLayoutPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'EndorsementsLayoutPageDataContext',
	dataProperty: 'pageData',
	getData: getEndorsementsLayoutPageData,
	hookDeps: ({ slug }) => [slug],
	getUniqueId: ({ slug }) => slug,
	errorHandler: pageDataErrorHandler<EndorsementsLayoutPageDataErrorCode>(),
});
